import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { api } from "../lib/api";
import { splitTitle } from "./Services";

const FALLBACK = [
  {
    quote: "They found an intermittent fault two dealerships had given up on. Diagnosed in a day, fixed for less than the original quote. This is my shop for life.",
    name: "Markus Weber",
    car: "Porsche 911 GT3 (992)",
  },
  {
    quote: "The ECU tune transformed my M5 — dyno sheet in hand, smooth everywhere, and they talked me out of spending more than I needed to. Rare honesty.",
    name: "Elena Fischer",
    car: "BMW M5 Competition",
  },
  {
    quote: "Full service history kept immaculate, photos of everything they touched, and the car came back cleaner than it went in. Precision is not a slogan here.",
    name: "Daniel Okafor",
    car: "Mercedes-AMG C63 S",
  },
];

export default function Testimonials({ content }) {
  const [items, setItems] = useState(FALLBACK);

  useEffect(() => {
    api.get("/testimonials")
      .then((res) => { if (Array.isArray(res.data) && res.data.length) setItems(res.data); })
      .catch(() => {});
  }, []);

  const eyebrow = content?.testimonials_eyebrow || "04 /// WORD OF MOUTH";
  const [titleA, titleB] = splitTitle(content?.testimonials_title || "Trusted by drivers");

  return (
    <section id="testimonials" className="border-y border-[#263342] bg-[#0D1117] py-24 sm:py-32" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.35em] text-crimson font-semibold mb-4">{eyebrow}</p>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-slate-100">
            {titleA} <span className="text-outline">{titleB}</span>
          </h2>
        </motion.div>

        <div className="mt-14 grid md:grid-cols-3 gap-4" data-testid="testimonials-grid">
          {items.map((t, i) => (
            <motion.figure
              key={t.id || t.name}
              data-testid={`testimonial-card-${i}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="bg-panel border border-[#263342] p-8 flex flex-col justify-between hover:border-crimson/40 transition-colors"
            >
              <blockquote className="text-slate-300 text-sm sm:text-base leading-relaxed">
                <span className="font-display text-4xl text-crimson leading-none block mb-3">"</span>
                {t.quote}
              </blockquote>
              <figcaption className="mt-8">
                <p className="font-display font-bold uppercase tracking-wide text-slate-100">{t.name}</p>
                {t.car && <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mt-1">{t.car}</p>}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
